import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './Carousel.css';

class Carousel extends React.Component {
  timeoutId = 0;

  constructor() {
    super();
    this.state = {
      activeIndex: 0,
    };
  }

  componentDidMount() {
    this._scheduleNextSlide();
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }

  render() {
    return (
      <div className={styles.carousel}>
        {this._renderMainView()}
        {this._renderPreviews()}
      </div>
    );
  }

  _scheduleNextSlide = () => {
    this.timeoutId = setTimeout(() => {
      const { activeIndex } = this.state;
      const { items } = this.props;

      this._scheduleNextSlide();
      this.setState({
        activeIndex: (activeIndex + 1) % items.length,
      });
    }, this.props.changeInterval);
  };

  _handleClick = index => {
    clearTimeout(this.timeoutId);
    this._scheduleNextSlide();

    this.setState({
      activeIndex: index,
    });
  };

  _renderMainView = () => {
    const { activeIndex } = this.state;
    const { items } = this.props;
    const slides = items.map((item, index) => (
      <img
        key={`slide-${index}`}
        src={item}
        className={activeIndex === index ? styles.selected : null}
      />
    ));

    return <div className={styles['carousel-active']}>{slides}</div>;
  };

  _renderPreviews = () => {
    const { activeIndex } = this.state;
    const { items, previewClassName } = this.props;
    const slides = items.map((item, index) => (
      <li
        key={`slide-${index}`}
        onClick={() => this._handleClick(index)}
        className={activeIndex === index ? styles.selected : null}
      >
        <img src={item} />
      </li>
    ));

    return (
      <ul className={classNames(styles['carousel-previews'], previewClassName)}>
        {slides}
      </ul>
    );
  };
}

Carousel.defaultProps = {
  activeIndex: 0,
  changeInterval: 5000,
  items: [],
};

Carousel.propTypes = {
  activeIndex: PropTypes.number,
  changeInterval: PropTypes.number,
  items: PropTypes.array,
  previewClassName: PropTypes.string,
};

export default Carousel;
